import { AutoScrollOptions } from '../types/options';


/**
 * Default options for the AutoScroll extension.
 *
 * @since 0.1.0
 */
export const DEFAULTS: AutoScrollOptions = {
  speed       : 1,
  autoStart   : true,
  pauseOnHover: true,
  pauseOnFocus: true,
};